import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarnProps = {
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarn: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarnProps
> = props => {
  let component = props.component,
    version = props.version;
  return (
    <div className="grid">
      <div className="grid__item col-1-1 pt- pl0">Yarn:</div>
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          yarn add {component.name}@{version.version}
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarn;
